import React from "react";
import { Dialog as MuiDialog, styled } from "@mui/material";

export interface DialogInterface {
  height?: string | number;
  size?: string | number;
  open: boolean;
  children?: React.ReactNode;
  onClose?: () => void;
  id?: string;
}

const CustomDialog = styled(MuiDialog, {
  shouldForwardProp: (prop) => prop !== "size" && prop !== "height",
  name: "CustomDialog",
})<{ height?: string | number; size?: string | number }>(
  ({ height, size }) => ({
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: size,
      height: height,
      border: "0px solid #000",
      borderRadius: 0,
    },
  })
);

const Dialog = ({
  open,
  height,
  size = 750,
  onClose,
  children,
  id,
}: DialogInterface) => {
  return (
    <CustomDialog
      open={open}
      height={height}
      size={size}
      onClose={onClose}
      id={id}
    >
      {children}
    </CustomDialog>
  );
};
export default Dialog;
